export default __webpack_public_path__ + "static/media/arrow-down.a2e0e1e3.svg";